var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user off",
    clipPath: "url(#clip0_878_2827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.68392 8.34898C2.87498 9.0625 2.29331 10.4028 2.27399 11.6435C2.2725 11.727 2.29539 11.8092 2.33986 11.8799C2.38432 11.9506 2.44844 12.0068 2.52436 12.0417C3.88733 12.6673 6.25349 13.0156 6.99998 13.0156C7.82213 13.0156 10.0937 12.8438 11.125 12.5L5.96873 7.34375C4.93748 7.34375 3.97866 8.089 3.68392 8.34898Z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.84375 1.84375L12.1563 12.1563",
    stroke: "#9CA3AF",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.76118 5.50432C8.28172 5.27256 8.68887 4.84351 8.89307 4.31156C9.09727 3.7796 9.08179 3.18832 8.85003 2.66778C8.61827 2.14724 8.18922 1.74009 7.65726 1.53589C7.12531 1.33169 6.53402 1.34717 6.01348 1.57893C5.49294 1.81069 5.08579 2.23974 4.88159 2.7717L7.76118 5.50432Z",
    fill: "#9CA3AF",
    stroke: "#9CA3AF",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_878_2827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.75,
    height: 13.75,
    fill: "white",
    transform: "translate(0.125 0.125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOff);
export default __webpack_public_path__ + "static/media/user_off.08901e4f.svg";
export { ForwardRef as ReactComponent };